import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { analyticsApi } from "./api/analyticsApi";
import { authApi } from "./api/authApi";
import { bookingApi } from "./api/bookingApi";
import { eventApi } from "./api/eventApi";
import { groundApi } from "./api/groundApi";
import { paymentApi } from "./api/paymentApi";
import { userApi } from "./api/userApi";
import { authMiddleware } from "./middleware/authMiddleware";
import { errorMiddleware } from "./middleware/errorMiddleware";
import authSlice from "./slices/authSlice";
import bookingSlice from "./slices/bookingSlice";
import eventSlice from "./slices/eventSlice";
import groundSlice from "./slices/groundSlice";
import uiSlice from "./slices/uiSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    ground: groundSlice,
    event: eventSlice,
    booking: bookingSlice,
    ui: uiSlice,
    [authApi.reducerPath]: authApi.reducer,
    [groundApi.reducerPath]: groundApi.reducer,
    [eventApi.reducerPath]: eventApi.reducer,
    [bookingApi.reducerPath]: bookingApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [analyticsApi.reducerPath]: analyticsApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    })
      .concat(authApi.middleware)
      .concat(groundApi.middleware)
      .concat(eventApi.middleware)
      .concat(bookingApi.middleware)
      .concat(paymentApi.middleware)
      .concat(userApi.middleware)
      .concat(analyticsApi.middleware)
      .concat(authMiddleware)
      .concat(errorMiddleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
